import { useEffect } from 'react';

const SEOHead = ({ 
  title = 'Shopping Gamification', 
  description = 'Sistema de gamificação para shopping centers com roleta de prêmios e vouchers exclusivos',
  keywords = 'shopping, gamificação, prêmios, vouchers, roleta, ofertas',
  ogImage = '/pwa-512x512.png',
  ogUrl = window.location.href
}) => {
  useEffect(() => {
    // Update title
    document.title = title;

    // Update meta tags
    const updateMetaTag = (name, content, property = false) => {
      const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
      let tag = document.querySelector(selector);
      
      if (!tag) {
        tag = document.createElement('meta');
        if (property) {
          tag.setAttribute('property', name);
        } else {
          tag.setAttribute('name', name);
        }
        document.head.appendChild(tag);
      }
      
      tag.setAttribute('content', content);
    };

    // Standard meta tags
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('author', 'Shopping Gamification Team');
    updateMetaTag('robots', 'index, follow');
    updateMetaTag('viewport', 'width=device-width, initial-scale=1.0');

    // Open Graph / Facebook
    updateMetaTag('og:title', title, true);
    updateMetaTag('og:description', description, true);
    updateMetaTag('og:image', ogImage, true);
    updateMetaTag('og:url', ogUrl, true);
    updateMetaTag('og:type', 'website', true);
    updateMetaTag('og:locale', 'pt_BR', true);
    updateMetaTag('og:site_name', 'Shopping Gamification', true);

    // Twitter Card
    updateMetaTag('twitter:card', 'summary_large_image');
    updateMetaTag('twitter:title', title);
    updateMetaTag('twitter:description', description);
    updateMetaTag('twitter:image', ogImage);

    // App-specific
    updateMetaTag('apple-mobile-web-app-capable', 'yes');
    updateMetaTag('apple-mobile-web-app-status-bar-style', 'default');
    updateMetaTag('apple-mobile-web-app-title', 'Shopping Gamification');
    updateMetaTag('mobile-web-app-capable', 'yes');
    updateMetaTag('application-name', 'Shopping Gamification');
    updateMetaTag('theme-color', '#13a4ec');
    updateMetaTag('msapplication-TileColor', '#13a4ec');

    // Structured Data (JSON-LD)
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Shopping Gamification",
      "description": description,
      "url": ogUrl,
      "logo": ogImage,
      "sameAs": [],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+55-11-99999-9999",
        "contactType": "customer service"
      }
    };

    // Remove existing structured data
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Add new structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

  }, [title, description, keywords, ogImage, ogUrl]);

  return null; // This component doesn't render anything
};

export default SEOHead;